'use es6';

import once from 'transmute/once';
import { DragDropContext, HTML5Backend } from 'react-dnd-compat';
export default once(() => DragDropContext(HTML5Backend));